(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-mc-grid-tiles]');
  if (!cfgEl) return;

  var tiles;
  try {
    tiles = JSON.parse(cfgEl.textContent || '[]');
  } catch (e) {
    return;
  }
  if (!Array.isArray(tiles) || !tiles.length) return;

  tiles = tiles
    .filter(function (t) {
      return t && t.image;
    })
    .slice(0, 8)
    .map(function (t, i) {
      return {
        position: Math.max(1, parseInt(t.position, 10) || i + 1),
        wide: !!t.wide,
        image: String(t.image),
        eyebrow: t.eyebrow ? String(t.eyebrow) : '',
        heading: t.heading ? String(t.heading) : '',
        link: t.link ? String(t.link) : '#',
        cta: t.cta ? String(t.cta) : '',
      };
    })
    .sort(function (a, b) {
      return a.position - b.position;
    });

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildTile(t) {
    var el = document.createElement('div');
    el.className = 't4s-col-item mc-grid-tile' + (t.wide ? ' mc-grid-tile--wide' : '');
    el.setAttribute('data-mc-grid-tile', '');
    el.innerHTML =
      '<a class="mc-grid-tile__link" href="' +
      esc(t.link) +
      '">' +
      '<img class="mc-grid-tile__img" src="' +
      esc(t.image) +
      '" alt="' +
      esc(t.heading) +
      '" loading="lazy" decoding="async">' +
      '<span class="mc-grid-tile__content">' +
      (t.eyebrow ? '<span class="mc-grid-tile__eyebrow">' + esc(t.eyebrow) + '</span>' : '') +
      (t.heading ? '<span class="mc-grid-tile__heading">' + esc(t.heading) + '</span>' : '') +
      (t.cta ? '<span class="mc-grid-tile__cta">' + esc(t.cta) + '</span>' : '') +
      '</span>' +
      '</a>';
    return el;
  }

  var observers = new WeakMap();

  function inject(grid) {
    var ob = observers.get(grid);
    if (ob) ob.disconnect();

    grid.querySelectorAll(':scope > [data-mc-grid-tile]').forEach(function (n) {
      n.remove();
    });

    var products = grid.querySelectorAll(':scope > .t4s-product:not([data-mc-grid-tile])');
    if (products.length) {
      tiles.forEach(function (t) {
        var idx = Math.min(t.position - 1, products.length);
        var ref = products[idx] || null;
        grid.insertBefore(buildTile(t), ref);
      });
    }

    if (ob) {
      requestAnimationFrame(function () {
        ob.observe(grid, { childList: true });
      });
    }
  }

  function watch(grid) {
    if (observers.has(grid)) return;
    var pending = false;
    var ob = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        inject(grid);
      });
    });
    observers.set(grid, ob);
    inject(grid);
    ob.observe(grid, { childList: true });
  }

  function boot() {
    var grids = document.querySelectorAll('.t4s_box_pr_grid.t4s-products');
    grids.forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
